export default {
      id: "next-logo-usage",
      viewBox: "0 0 257 130",
      url: __webpack_public_path__ + "sprite.svg#next-logo-usage",
      toString: function () {
        return this.url;
      }
    }